module.exports = __webpack_public_path__ + "static/img/Image_003.74bbc16.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/Image_003.png
// module id = FJte
// module chunks = 3